import React, { useRef, useState } from 'react';
import { ReactComponent as JoyHeartIconSvg } from '@images/joy-heart.svg';
import { styled } from '@styledComponents';
import { Text } from '@components/typography';
import { themeColor } from '@utils/styledTheme.util';
import { animationTransition } from '@utils/animationTransition';

const MobileAccordionHeader = styled.div<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 32px;
  padding-right: 32px;
  > svg {
    color: ${({ isActive }) => themeColor(isActive ? 'yellow5' : 'neutra6')};
    opacity: ${({ isActive }) => (isActive ? 1 : 0.5)};
    transition: ${animationTransition('transform')};
    transform: ${({ isActive }) => (isActive ? 'rotate(-180deg)' : 'none')};
  }
`;

const MobileAccordionContent = styled.div<{ isActive: boolean; padding?: string }>`
  padding-top: ${({ isActive, padding }) => (isActive ? (padding ? padding : '20px') : 0)};
  height: ${({ isActive }) => (isActive ? 'fit-content' : 0)};
  overflow: hidden;
  transform-origin: top;
  transition: ${animationTransition('height')};
`;

export const StyledArrowSvg = styled.svg<{ isOpen?: boolean }>`
  top: 4px;
  right: -5px;
  position: relative;
  ${({ isOpen }) =>
    isOpen
      ? {
          transform: 'rotate(180deg)',
        }
      : null}
`;

export const StyledBorder = styled.div`
  position: relative;
  background: rgb(235, 235, 235);
  left: 32px;
  width: 83%;
  height: 1px;
  top: 18px;
`;

interface Props {
  headerText: string;
  padding?: string;
  style?: React.CSSProperties;
}

const MobileFilterAccordion: React.FC<Props> = ({ headerText, style, children, padding }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const contentElRef = useRef<HTMLDivElement>(null);

  return (
    <div style={style}>
      <MobileAccordionHeader isActive={!isCollapsed} onClick={() => setIsCollapsed(!isCollapsed)}>
        <Text variant="featureHed17" tagName="span" color={'neutra6'}>
          {headerText}
        </Text>
        <StyledArrowSvg isOpen={isCollapsed} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.2525 8.80122C18.4868 9.03554 18.4868 9.41544 18.2525 9.64975L13.1312 14.7711C12.5063 15.3959 11.4933 15.3959 10.8684 14.7711L5.74898 9.65162C5.51466 9.41731 5.51466 9.03741 5.74898 8.80309C5.98329 8.56878 6.36319 8.56878 6.59751 8.80309L11.717 13.9225C11.8732 14.0788 12.1264 14.0788 12.2826 13.9225L17.404 8.80122C17.6383 8.56691 18.0182 8.56691 18.2525 8.80122Z"
            fill="#333333"
          />
        </StyledArrowSvg>
      </MobileAccordionHeader>
      <MobileAccordionContent isActive={!isCollapsed} ref={contentElRef} padding={padding}>
        {children}
      </MobileAccordionContent>
      <StyledBorder></StyledBorder>
    </div>
  );
};

export default MobileFilterAccordion;
